// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-picker {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 20px;
  justify-content: center;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/TimePicker/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,WAAW;AACb","sourcesContent":[".time-picker {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 20px;\n  justify-content: center;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
